// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar flat>
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        <v-toolbar-title v-if="newRole">Add Role</v-toolbar-title>
        <v-toolbar-title v-else>Edit Role</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="canModify" color="blue" @click="save">Save</v-btn>
      </v-toolbar>
      <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Name"
            v-model="role.name"
            required
            hide-details
            :disabled="!canModify"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field
            name="input"
            label="Company ID"
            v-model="companyID"
            hide-details
            :disabled="!canModify"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 v-if="!newRole">
          <v-card flat>
            <v-card-text>
              <p class="display-1">User Roles</p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="!newRole">
          <v-data-table
          v-bind:headers="headers"
          :items="computedAccessRules"
          :rows-per-page-items="[25, { text: 'All', value: -1 }]"
          >
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                {{ props.item.resourceType }}
              </td>
              <td class="text-xs-left">
                {{ props.item.resourceID }}
              </td>
              <td class="text-xs-left">
                {{ intToPermission(props.item.permissions) }}
              </td>
              <td class="text-xs-left">
                {{ checkWildcard(props.item.roleID) }}
              </td>

            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
    </v-card>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import {PERMISSIONS, WILDCARDBSON} from 'vue-common/components/constants'
import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
import {checkPermission} from 'vue-common/components/user'
import {checkWildcard, intToPermission} from 'vue-common/components/utils'

import {AXIOSAPI} from '@/api/api'
import {ENDPOINT} from '@/shared/constants'

export default {
  components: {
    ErrorSnackbar
  },

  data () {
    return {
      localAccessRules: [],
      endpoint: ENDPOINT,
      errorText: '',
      headers: [
        {
          text: 'Resource Type',
          value: 'resourceType',
          align: 'left'
        },
        {
          text: 'Resource ID',
          value: 'resourceID',
          align: 'left'
        },
        {
          text: 'Permissions',
          value: 'permissions',
          align: 'left'
        },
        {
          text: 'Role ID',
          value: 'roleID',
          align: 'left'
        }
      ],
      newRole: false,
      role: {}
    }
  },

  created () {
    if (this.$route.params.id === 'new') {
      this.newRole = true
    }

    this.getAccessRules()
    this.getRole()
  },

  computed: {
    ...mapGetters([
      'accessRules'
    ]),

    canModify: function () {
      return checkPermission(this.accessRules, 'roles', PERMISSIONS.MODIFY)
    },

    companyID: function () {
      return checkWildcard(this.role.companyID)
    },

    computedAccessRules: function () {
      var list = []
      for (var i in this.localAccessRules) {
        if (this.localAccessRules[i].roleID === WILDCARDBSON) {
          list.push(this.localAccessRules[i])
        } else if (this.localAccessRules[i].roleID === this.role.id) {
          list.push(this.localAccessRules[i])
        }
      }
      return list
    }
  },

  methods: {
    checkWildcard: function (val) {
      var x = checkWildcard(val)
      if (!(x === '' || x === 'Global')) {
        return this.role.name
      }
      return x
    },

    intToPermission: function (val) {
      return intToPermission(val)
    },

    getRole: function () {
      if (this.newRole) {
      } else {
        AXIOSAPI.get(ENDPOINT + 'roles/' + this.$route.params.id).then((response) => {
          this.role = response.data
        })
      }
    },

    getAccessRules: function () {
      AXIOSAPI.get(ENDPOINT + 'accessRules').then((response) => {
        this.localAccessRules = response.data
      })
    },

    save: function () {
      if (this.role.name !== '' && this.role.name) {
        if (this.newRole) {
          AXIOSAPI.post(ENDPOINT + 'roles', this.role).then(response => {
            this.exit()
          }).catch(e => {
            console.log(e)
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        } else {
          AXIOSAPI.put(ENDPOINT + 'roles/' + this.$route.params.id, this.role).then(response => {
            this.exit()
          }).catch(e => {
            console.log(e)
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        }
      } else {
        this.errorText = 'Please completely fill out the form'
      }
    },

    exit: function () {
      this.$router.push({name: 'roles'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RoleEdit.vue